define('modules/editor/models/pagestate',['require','exports','module','backbone'],function(require, exports, module) {
  var Backbone = require("backbone");

  module.exports = Backbone.Model.extend({
    setDragPayload: function(type, op, model) {
      this._dragPayload = {
        type: type,
        op: op,
        model: model
      };
    },
    setDragOffset: function(offset) {
      this._dragOffset = offset;
    },
    setDropPosition: function(position) {
      this._dropPosition = position;
    },
    getDropPosition: function(position) {
      return this._dropPosition;
    },
    getDragPayload: function() {
      return this._dragPayload;
    },
    getDragOffset: function() {
      return this._dragOffset || {x: 0, y: 0};
    },
    clearDragPayload: function() {
      this._dragPayload = null;
    }
  });

});

